import React from "react";
import { useParams } from "react-router-dom";
import { useI18n } from "@/contexts/I18nContext";
import { Section, Eyebrow, Reveal } from "@/components/site/Primitives";

const CONTENT = {
  legal: {
    title: { en: "Legal", fr: "Mentions légales", es: "Aviso legal" },
    body: {
      en: "Strategy Intelligence Solutions LTD is a company registered in England & Wales. This page provides statutory information regarding the company's identity, registered office, and applicable legal notices.",
      fr: "Strategy Intelligence Solutions LTD est une société immatriculée en Angleterre et au Pays de Galles. Cette page fournit les informations légales relatives à l'identité de la société, à son siège social et aux mentions légales applicables.",
      es: "Strategy Intelligence Solutions LTD es una empresa registrada en Inglaterra y Gales. Esta página proporciona información legal sobre la identidad de la empresa, su sede social y los avisos legales aplicables.",
    },
  },
  privacy: {
    title: { en: "Privacy", fr: "Confidentialité", es: "Privacidad" },
    body: {
      en: "We process personal data in accordance with the UK GDPR and the Data Protection Act 2018. Please refer to this policy for information on how we collect, use, retain, and disclose personal information, and how you can exercise your rights.",
      fr: "Nous traitons les données personnelles conformément au RGPD britannique et au Data Protection Act 2018. Cette politique décrit comment nous collectons, utilisons, conservons et divulguons les informations personnelles, et comment vous pouvez exercer vos droits.",
      es: "Tratamos los datos personales conforme al RGPD del Reino Unido y a la Data Protection Act 2018. Esta política describe cómo recopilamos, usamos, conservamos y divulgamos la información personal, y cómo puede ejercer sus derechos.",
    },
  },
  cookies: {
    title: { en: "Cookies", fr: "Cookies", es: "Cookies" },
    body: {
      en: "We use a minimal set of first-party cookies to deliver core functionality and language preferences. No third-party advertising cookies are set without your consent.",
      fr: "Nous utilisons un ensemble minimal de cookies internes pour assurer les fonctionnalités essentielles et les préférences linguistiques. Aucun cookie publicitaire tiers n'est déposé sans votre consentement.",
      es: "Utilizamos un conjunto mínimo de cookies propias para ofrecer funcionalidades esenciales y preferencias de idioma. No se instalan cookies publicitarias de terceros sin su consentimiento.",
    },
  },
  terms: {
    title: { en: "Terms", fr: "Conditions", es: "Términos" },
    body: {
      en: "These terms govern access to and use of this website. The content provided is for informational purposes only and does not constitute an offer to sell or a solicitation of an offer to buy any security or financial product.",
      fr: "Ces conditions régissent l'accès à ce site et son utilisation. Le contenu fourni est à des fins d'information uniquement et ne constitue ni une offre de vente ni une sollicitation d'offre d'achat.",
      es: "Estos términos rigen el acceso y uso de este sitio. El contenido es meramente informativo y no constituye una oferta de venta ni una solicitud de compra.",
    },
  },
};

export default function LegalPage({ slug: propSlug }) {
  const { slug: paramSlug } = useParams();
  const { lang, t } = useI18n();
  const slug = propSlug || paramSlug || "legal";
  const doc = CONTENT[slug] || CONTENT.legal;

  return (
    <Section className="pt-28 md:pt-40 min-h-[80vh]">
      <Eyebrow>{t("footer.legal")}</Eyebrow>
      <Reveal>
        <h1 className="mt-6 font-display font-light text-5xl md:text-6xl leading-[0.98] tracking-[-0.03em]">{doc.title[lang] || doc.title.en}</h1>
      </Reveal>
      <Reveal delay={0.1}>
        <p className="mt-10 max-w-3xl text-lg text-muted-foreground leading-relaxed">{doc.body[lang] || doc.body.en}</p>
      </Reveal>
      <Reveal delay={0.2}>
        <p className="mt-12 text-[12px] tracking-widest uppercase text-muted-foreground">Last updated · February 2026</p>
      </Reveal>
    </Section>
  );
}
